<script setup lang="ts">
import { TabMenu, CloseButton } from '../..';
import type { IItems } from '../../TabMenu.vue';

defineProps<{
  id?: string | undefined
  options?: IItems[]
}>()

const emit = defineEmits<{ (e: 'close'): void }>()

const selectedOption = defineModel<number>('selectedOption', { default: 1 })
</script>

<template>
  <div class="flex items-center justify-between mb-2 pb-3">
    <div class="flex flex-col">
      <h3 class="font-semibold text-lg text-primary leading-none">
        <slot name="title" />
      </h3>
      <h4 v-if="id" class="text-base text-sm text-gray-400 dark:text-white/90 skeleton-box">
        ID: <span class="text-xs">{{ id }}</span>
      </h4>
    </div>
    <TabMenu v-if="options?.length" :items="options" v-model="selectedOption" class="ml-auto mr-5" />
    <CloseButton @click="emit('close')" />
  </div>
</template>
